import { render, staticRenderFns } from "./ModalCoupon.vue?vue&type=template&id=2d6e5312&"
import script from "./ModalCoupon.vue?vue&type=script&lang=js&"
export * from "./ModalCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports